import styles from "../index.css";
import {scenario} from "../../../stores";
import React, { Component } from 'react';
import {observer} from 'mobx-react';

@observer
class PathPopupButtons extends Component{
    render() {
        return (
            <div className={styles.pathButtons}>
                <div className={styles.button + ' ' + (scenario.script.length ? styles.disabled : styles.inactive)}
                     onClick={() => {
                         scenario.setDefaultScript()
                     }}>
                    Очистити сценарій
                </div>
                <div className={styles.button + ' ' + styles.disabled}
                     onClick={() => {
                         scenario.closePathPopup()
                     }}>
                    Скасувати
                </div>
                <div className={styles.button + (scenario.getIsActiveSetScenarioButton ? '' : " " + styles.inactive)}
                     onClick={() => {
                         scenario.setScenario()
                     }}>
                    застосувати
                </div>
            </div>
        )
    }
};

export default PathPopupButtons


// WEBPACK FOOTER //
// ./src/shared/components/PathPopup/PathPopupButtons/index.js